<script setup lang="ts"></script>

<template>
  <div class="w-full lg:w-1/2">
    <img
      src="/images/solarium/2.webp"
      class="aspect-video w-full rounded-lg object-cover lg:aspect-auto"
    />
  </div>
</template>
